<div *ngIf="formGroup" class="input__container" [formGroup]="formGroup">
  <label
    *ngIf="labelPrimaria"
    class="label__input__lovers"
    [ngClass]="{ disabled: disabled, dark: darkMode }"
    [for]="idCampo"
    >{{ label }}</label
  >
  <label
    *ngIf="labelAceite"
    class="label__input__lovers"
    [ngClass]="{ disabled: disabled, dark: darkMode }"
    [for]="idCampo"
    >Li e aceito os
    <span [ngClass]="{termos:labelBranca}" (click)="onLinkClick($event, 'Termos')"> Termos de uso</span>
    e
    <span [ngClass]="{termos:labelBranca}" (click)="onLinkClick($event, 'Regulamentos')"> Regulamento</span>
    do Programa Cacau Lovers</label
  >
  <input
    [id]="idCampo"
    [name]="name"
    class="ui-checkbox"
    [(ngModel)]="ngModel"
    type="checkbox"
    [formControlName]="controlName"
    [value]="controlName"
    (change)="onInputChange()"
  />
</div>
